const pick = (obj, props) => obj && Object.keys(obj).reduce((res, key) => {
  if (~props.indexOf(key)) {
    res[key] = obj[key];
  }
  return res;
}, {});
export default pick;